import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Popup, Menu, Label } from 'semantic-ui-react';
import { UserDTO } from '@api/user/dtos/UserDTO';
import useGetUser from '@api/user/hooks/useGetUser';

import styles from './Username.module.scss';

const getAuthorities = (user: UserDTO): string[] => user.authorities;

function Username() {
  const { data: user } = useGetUser();
  const { t } = useTranslation();

  if (!user) {
    return null;
  }

  const authorities: string[] = getAuthorities(user);
  const authoritiesLabels: React.ReactNode[] = [];
  authorities.forEach(authority => {
    authoritiesLabels.push(
      <Label key={authority} color="blue" horizontal className={styles.role}>
        {authority}
      </Label>
    );
  });

  return (
    <Menu.Item key="user">
      <Popup
        key="userRolesToolTip"
        className="userRoles"
        trigger={
          <Menu.Item>
            <Icon name="user" />
            {String(user.login).toLowerCase()}
          </Menu.Item>
        }
        size="mini"
        position="bottom right"
      >
        {t('header.roles')}
        <div>{authoritiesLabels}</div>
      </Popup>
    </Menu.Item>
  );
}

export default Username;
